import { Reveal } from "./Reveal";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";

const photos = [
  { src: "/foto-a.webp", srcset: "/foto-a-480.webp 480w, /foto-a-768.webp 768w, /foto-a.webp 1600w", label: "La sala operatoria della struttura convenzionata" },
  { src: "/foto-relatore.jpg", label: "Il Dr. Gattuso relatore a un congresso di chirurgia" },
  { src: "/foto-b.webp", srcset: "/foto-b-480.webp 480w, /foto-b-768.webp 768w, /foto-b.webp 1600w", label: "La camera di degenza — Day Surgery convenzionata" },
  { src: "https://static.prod-images.emergentagent.com/jobs/c24763e7-4110-455f-bc22-09e351652797/images/310649150f7b8588bf0b57182b0d4c035c21bcda87baaca641d756047881d151.jpeg", label: "La valutazione iniziale" },
  { src: "https://static.prod-images.emergentagent.com/jobs/c24763e7-4110-455f-bc22-09e351652797/images/c40a344b61de61319020725663afa5bf37373f2688e1759a8cfbf85de8a1fa7f.jpeg", label: "Impianti zigomatici su modello anatomico" },
  { src: "https://static.prod-images.emergentagent.com/jobs/c24763e7-4110-455f-bc22-09e351652797/images/948eabf55c78f1f9d15d42bbb615c7304157a9ac32c67da7c0b506c6966d1ed4.jpeg", label: "Protesi All on Four su impianti" },
];

export const Gallery = () => (
  <section id="galleria" className="py-24 md:py-32 px-6 md:px-12 bg-[#EAF4F8]" data-testid="gallery-section">
    <div className="max-w-7xl mx-auto">
      <Reveal>
        <p className="text-sm uppercase tracking-[0.2em] font-bold text-[#7D9285] mb-4">La nostra realtà</p>
        <h2 className="font-serif-display font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#15201A] max-w-3xl">
          Dentro i nostri <em className="italic text-[#385244]">studi</em>
        </h2>
        <p className="mt-6 text-base md:text-lg leading-relaxed text-[#5C6B61] max-w-2xl">
          Per gli interventi più complessi in anestesia generale è attiva la{" "}
          <strong className="text-[#15201A]">convenzione con una struttura in Day Surgery</strong>,
          con sala attrezzata, anestesista dedicato e degenza (costo a parte).
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <Carousel opts={{ loop: true, align: "start" }} className="mt-14">
          <CarouselContent>
            {photos.map((p, i) => (
              <CarouselItem key={p.src} className="md:basis-1/2 lg:basis-1/3" data-testid={`gallery-slide-${i}`}>
                <figure>
                  <img src={p.src} srcSet={p.srcset} sizes={p.srcset ? "(max-width: 768px) 100vw, 33vw" : undefined} alt={p.label} loading="lazy" decoding="async" className="w-full h-72 object-cover rounded-[24px] border border-border" />
                  <figcaption className="mt-3 text-sm font-semibold text-[#5C6B61]">{p.label}</figcaption>
                </figure>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="left-2 bg-white/90 border-border text-[#385244] hover:bg-[#385244] hover:text-white" data-testid="gallery-prev-btn" />
          <CarouselNext className="right-2 bg-white/90 border-border text-[#385244] hover:bg-[#385244] hover:text-white" data-testid="gallery-next-btn" />
        </Carousel>
      </Reveal>
    </div>
  </section>
);
